import _ from 'lodash';
import React, {useState, useEffect} from 'react';
import {Table, TableBody, TableFooter, TableRow, TableCell} from '@material-ui/core';
import {ProductInCatalog} from '@treez/commons/sharedTypings/product';
import {ModalType} from '@treez-ui/core/feedback/modals';
import StoreMatrixRow from './StoreMatrixRow';
import StoreMatrixTableHeader from './StoreMatrixTableHeader';
import {StoreAttributes} from '~/lib/directory';
import {getCatalogProductData, ProductsPresenceAcrossStores} from '~/utils/ProductAPI';
import {
    openFeedbackModal,
    closeFeedbackModal,
} from '~/redux/boundActionCreators/UserFeedbackActions';
import {useOrgCatalogState} from '~/contexts/OrgCatalog/orgCatalogContext';

const failedToRetrieveStorePresenceTitle = 'Error Retrieving Product';
const failedToRetrieveStorePresenceBody =
    'There was an error retrieving the products store level information';

interface Props {
    products: ProductInCatalog[];
    stores: StoreAttributes[];
}

export const StoreMatrixTable = (props: Props) => {
    const {products, stores} = props;

    const {fetching} = useOrgCatalogState();

    const alertUserOfFailedStorePresence = () => {
        openFeedbackModal(closeFeedbackModal, failedToRetrieveStorePresenceTitle, {
            bodyText: `${failedToRetrieveStorePresenceBody}:
                    Could not contact api server.`,
            type: ModalType.ERROR,
        });
    };

    const catalogIds = _.map(stores, (store) => {
        return store.catalogId;
    }) as number[];

    const productIds = _.map(products, 'id') as number[];

    const [productsStorePresence, setProductsStorePresence] =
        useState<ProductsPresenceAcrossStores>({});

    useEffect(() => {
        if (_.size(stores) > 0 && _.size(products) > 0) {
            getCatalogProductData(catalogIds, productIds)
                .then((result) => {
                    setProductsStorePresence(result);
                })
                .catch((error) => {
                    console.error(error);
                    alertUserOfFailedStorePresence();
                });
        }
    }, [stores, products]);

    return (
        <div className="store-matrix-table-container">
            <Table className="store-matrix-table" size="small">
                <StoreMatrixTableHeader />
                {fetching === false && (
                    <TableBody>
                        {_.map(products, (product) => {
                            const {id} = product;
                            if (id == null) {
                                console.error(
                                    `Product: ${product.name} does not have an id associated with it and thus can not have any store presence`
                                );
                                return;
                            }
                            return (
                                <StoreMatrixRow
                                    key={id}
                                    product={product}
                                    storePresence={productsStorePresence[id] || []}
                                    stores={stores || []}
                                />
                            );
                        })}
                    </TableBody>
                )}
                <TableFooter>
                    <TableRow className="matrix-table-footer">
                        <TableCell colSpan={stores ? stores.length + 1 : 2} />
                    </TableRow>
                </TableFooter>
            </Table>
        </div>
    );
};

export default React.memo(StoreMatrixTable);
